// ─── Fase 18 · retardo simulado + sincronía de la animación de carga ─────────
// Genera una duración aleatoria (5–10 s) por ejecución. El handler la usa para
// retener el estado de carga y SimulatingScreen la lee para cronometrar su
// animación, de modo que la barra llega al ~100 % justo cuando aparecen los
// resultados. Solo hay una simulación activa a la vez, así que un valor a nivel
// de módulo es suficiente y evita pasar props por toda la jerarquía.
let _dur = 7000;

export function beginSim() {
  _dur = 5000 + Math.floor(Math.random() * 5001); // 5000–10000 ms
  return _dur;
}

export function simDuration() {
  return _dur;
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
